import tool from 'Src/util/tool'
import { catchableParse } from 'Src/util/json'
const globalVar = tool.safetyGet(window, 'GLOBAL_VAR', {})
// 获取globalConf
const globalConf = tool.safetyGet(window, 'GLOBAL_CONF', {})
// 是否为新版黑名单
const adsBlackVersion = tool.isSupported(globalVar && globalVar.adver_func && globalVar.adver_func.promote_blacklist)
// 鲁班
const isEcAdvertiser = catchableParse(globalVar && globalVar.isEcAdvertiser)

// 橙子豁免名单
const isOrangeValid = tool.isSupported(globalVar && globalVar.adver_func && globalVar.adver_func.orange_valid_exempt_config)
// 橙子建站白名单豁免逻辑
// 优先判断tcc开关，关了之后，不限制，开了之后，先判断是否为内广，在判断二级行业
// 技术方案https://bytedance.feishu.cn/docs/doccnZDlgPON8CRsZD8Oqeu4CBc#
function isOrangeLimit () {
  // 先判断开关是否打开
  let orangeConfig = globalConf?.orange_valid_config || {}
  // 如果switch_orange_valid 为0则不校验，这里不要写成！！，以免后续不好扩展
  if (orangeConfig?.switch_orange_valid === 0) {
    return false
  }
  // 内广豁免开关是否打开
  let isInnerAdvExempt = orangeConfig?.inner_adv_exempt
  let advertiserRole = tool.safetyGet(globalVar, 'advertiser.role', '0')
  // 如果内广豁免名单打开了，并且是内广
  if (isInnerAdvExempt && +advertiserRole === 4) {
    return false
  }
  // 是否在豁免名单里面
  return !isOrangeValid
}

Vue.mixin({
  data () {
    return {
      // 黑名单或者鲁班
      adsNewVersion: (adsBlackVersion || isEcAdvertiser) ? 0 : 1,
      // 支持的推广目的
      newVersionLangingType: {
        // 应用推广
        3: 'app',
        // 销售线索收集
        1: 'external',
        // 快应用
        10: 'quick_app',
        // 直播间
        9: 'live',
        // 抖音号
        7: 'aweme',
        // 商品
        5: 'product_library',
        // 门店
        6: 'advertiser_store',
        // 电商店铺
        8: 'shop'
      },
      // 广告组判断逻辑，因为广告组的跳新逻辑和计划跳转逻辑不一样
      newCampaignVersionLangingType: {
        // 应用推广
        3: 'app',
        // 销售线索收集
        1: 'external',
        // 快应用
        10: 'quick_app',
        // 直播间
        9: 'live',
        // 抖音号
        7: 'aweme',
        // 商品
        5: 'product_library',
        // 电商店铺
        8: 'shop',
        // 门店
        6: 'advertiser_store'
      },
      // skan广告组
      skanMaxAdCount: globalConf?.ios_skan?.maxAdCount || 0,
      // 是否豁免橙子建站
      isOrangeLimit: isOrangeLimit()
    }
  },
  methods: {
    // 是否跳转到新版本
    isJudgeToNewVersion (adInfo) {
      let sceneType = ''
      if (this.adsNewVersion && this.newVersionLangingType[adInfo.landing_type]) {
        // 新计划，必跳新的
        // 如果inventory_catalog > 1， 垂直化，跳转到新的
        if (adInfo.inventory_catalog || (+adInfo.marketing_scene === 0 && adInfo.download_type !== 3) || +adInfo.marketing_scene) {
          sceneType = this.newVersionLangingType[adInfo.landing_type]
        } else {
          sceneType = ''
        }
      }
      return sceneType
    },
    // skan组判断
    isJudgeSkan (info) {
      let dedicateType = typeof info === 'string' ? info : (info.campaign_dedicate_type || info.dedicate_type)
      return dedicateType === 2
    },
    // 判断广告组，是否能创建计划
    isJudgeSkanLimit (campaignId) {
      let maxAd = globalConf?.ios_skan?.maxAdCount || 0
      return new Promise((resolve, reject) => {
        BUI.fetch({
          url: '/nbs/api/ads/ad/get_ads_by_campainids',
          data: {
            campaign_id: campaignId
          },
          success: (resp) => {
            let overLimit = false
            if (resp.code === 0) {
              let count = resp.data.count
              overLimit = count >= maxAd
              resp.data.overLimit = overLimit
              resolve(resp)
            } else {
              reject(resp)
            }
          }
        })
      })
    }
  }
})
